import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import useWorkspacesStore from '@/state/workspaces.state';
import { PlusIcon } from '@/UI/Icons';
import { ButtonContained } from '@/UI/Buttons/AppButton';
import { TrackTypeEnum, useAnalytics } from '@/hooks/useAnalytics';
import { I18N_KEYS } from '../../language/keys';

interface DashboardHeaderProps {
  isShowCreateRecipeButton: boolean;
  createRecipe: () => Promise<void>;
}

export const DashboardHeader = ({ isShowCreateRecipeButton, createRecipe }: DashboardHeaderProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isNarrowScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { track } = useAnalytics();
  const workspaceName = useWorkspacesStore((state) => state.activeWorkspace.workspaceName);

  const onCreateRecipe = useCallback(() => {
    track('created_new_flow', { source: 'dashboard_header' }, TrackTypeEnum.BI);
    void createRecipe();
  }, [createRecipe, track]);

  return (
    <Box
      sx={{
        minHeight: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        flexShrink: 0,
        minWidth: 0,
      }}
    >
      <Typography variant="body-std-rg" noWrap title={workspaceName} sx={{ minWidth: 0, flex: 1 }}>
        {workspaceName}
      </Typography>
      {isShowCreateRecipeButton && (
        <ButtonContained
          aria-label={t(I18N_KEYS.MAIN_DASHBOARD.CREATE_NEW_FILE)}
          onClick={onCreateRecipe}
          startIcon={<PlusIcon width={16} height={16} />}
          sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}
        >
          {isNarrowScreen
            ? t(I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.CREATE_FILE)
            : t(I18N_KEYS.MAIN_DASHBOARD.CREATE_NEW_FILE)}
        </ButtonContained>
      )}
    </Box>
  );
};
